<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Documentos</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span
                v-if="countFilter > 0"
                class="badge badge-light"
              >{{countFilter}}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Documentos</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6
                    v-if="pagination.TotalItems > 0"
                    class="m-0"
                  >{{pagination.TotalItems | number}} {{pagination.TotalItems > 1 ? " itens" : "item"}}</h6>
                  <div class="dropdown m-0" v-if="pagination.TotalItems > 0">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      id="dropTableOptions"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : '' "
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader :small="true" :isLoading="loadingReport"></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0">Tipo de documento</th>
                    <th scope="col" class="border-0">Data de criação</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(partnerDoc, index) in partnerDocs" :key="index">
                    <td></td>
                    <td>{{partnerDoc.PartnerDocType.Name}}</td>
                    <td>{{partnerDoc.CreatedDate | date }}</td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >Opções</button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="GetPartnerDoc(partnerDoc.Id, true, false)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            :class="loadingDownload ? 'disabled' : '' "
                            v-on:click.stop="GetPartnerDoc(partnerDoc.Id, true, true)"
                          >
                            <template v-if="loadingDownload">
                              <loader :small="true" :isLoading="loadingDownload"></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-long-arrow-alt-down mr-2"></i>
                              Download
                            </template>
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            v-on:click="ConfirmDeletePartnerDoc($event, partnerDoc.PartnerDocType.Name, partnerDoc.Partner.Name ,partnerDoc.Id)"
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="partnerDocs == null || partnerDocs == undefined || partnerDocs.length == 0"
                  >
                    <td colspan="4">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFormPartnerDoc"
      size="lg"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <ValidationObserver ref="formValidation">
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Tipo de documento</label>
              <ValidationProvider rules="required" v-slot="{errors, invalid}">
                <d-select
                  :class="validatedFormValidation | showValidateError(invalid)"
                  v-model="infoPartnerDoc.PartnerDocType.Code"
                  :disabled="isSeeing"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="type in partnerDocTypes"
                    v-bind:value="type.Code"
                    v-bind:key="type.Code"
                  >{{type.Name}}</option>
                </d-select>
                <div class="invalid-feedback d-block" v-if="validatedFormValidation">{{ errors[0] }}</div>
              </ValidationProvider>
            </d-col>
            <d-col v-if="isSeeing">
              <!-- CreatedDate -->
              <label>Data de criação</label>
              <d-form-input
                type="text"
                v-bind:value="infoPartnerDoc.CreatedDate | date('DD/MM/YYYY - HH:mm')"
                readonly
              />
            </d-col>
            <!-- Url -->
            <d-col v-if="isCreating" md="6" class="form-group">
              <label>Arquivo</label>
              <b-form-file
                type="file"
                placeholder="Selecione ou arraste um arquivo"
                drop-placeholder="Solte o arquivo aqui"
                browse-text="Selecionar"
                accept="application/pdf"
                @change="SelectPartnerDocFile($event, true)"
                @input="SelectPartnerDocFile($event, false)"
              />
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>
      <template slot="modal-footer" slot-scope="{cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="AddPartnerDocValidated()"
          v-if="!isSeeing || isCreating"
        >
          {{isCreating == false ? "Salvar" : "Adicionar"}}
          <i class="fas fa-arrow-right"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <d-select v-model="filter.CodePartnerDocType" :value="null">
            <option :value="null" selected>Tipo de documento</option>
            <option
              v-for="type in partnerDocTypes"
              v-bind:key="type.Code"
              v-bind:value="type.Code"
            >{{type.Name}}</option>
          </d-select>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo documento"
      v-on:click="OpenMNewPartnerDoc()"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { FileToBase64 } from "../../utils/fileUtils.js";
import { hasValue } from "../../utils/functions.js";
import dateField from "@/components/common/date-field";
export default {
  name: "partner-docs",
  data: function () {
    return {
      countFilter: 0,
      filter: {
        IdPartner: null,
        CodePartnerDocType: null,
      },
      validatedFormValidation: false,
      loadingDownload: false,
      loadingList: false,
      loadingModal: false,
      loadingReport: false,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      paginationDocType: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      partnerDocs: [],
      partnerDocTypes: [],
      partners: [],
      infoPartnerDoc: {
        Partner: {
          Id: null,
        },
        PartnerDocType: {
          Code: null,
        },
        Url: null,
      },
      partnerDocFile: null,
      isSeeing: false,
      isCreating: false,
      modalTitle: "Novo documento",
    };
  },
  components: {
    dateField,
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListPartnerDoc();
    },
    "pagination.RowsPerPage": function () {
      this.ListPartnerDoc();
    },
  },
  mounted() {
    this.ListPartnerDoc();
    this.ListPartnerDocType();
  },
  methods: {
    SelectPartnerDocFile(obj, isEvent) {
      let file = null;
      if (isEvent) file = obj.target.files[0];
      else file = obj;
      if (file == null) return;

      if (file.type == "application/pdf") {
        this.partnerDocFile = file;
      } else {
        this.$makeToast(
          "O arquivo selecionado não é um PDF válido",
          "danger",
          "Documento"
        );
      }
    },
    AppendFormData(obj, form, namespace) {
      var fd = form || new FormData();
      var formKey;

      for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
          if (namespace) {
            formKey = namespace + "[" + property + "]";
          } else {
            formKey = property;
          }

          // if the property is an object, but not a File,
          // use recursivity.
          if (typeof obj[property] === "object") {
            this.AppendFormData(obj[property], fd, formKey);
          } else {
            if (typeof obj[property] === "number") {
              fd.append(formKey, obj[property].toString().replace(".", ","));
            } else {
              fd.append(formKey, obj[property]);
            }
          }
        }
      }

      return fd;
    },
    GetFormData(object) {
      return this.AppendFormData(object);
    },
    OpenMPartnerDoc: function () {
      this.validatedFormValidation = false;
      this.$bvModal.show("mFormPartnerDoc");
    },
    OpenMNewPartnerDoc: function () {
      this.ResetInfoPartnerDoc();
      this.isCreating = true;
      this.isSeeing = false;
      this.modalTitle = "Novo documento";
      this.OpenMPartnerDoc();
    },
    ResetInfoPartnerDoc: function () {
      this.infoPartnerDoc = {
        Partner: {
          Id: null,
        },
        PartnerDocType: {
          Code: null,
        },
        Url: null,
      };
    },
    AddPartnerDocValidated: function () {
      this.validatedFormValidation = true;
      this.$refs.formValidation.validate().then((valid) => {
        if (valid) {
          if (this.partnerDocFile != null && this.partnerDocFile != undefined) {
            this.AddPartnerDoc();
          } else {
            this.$makeToast("Selecione um arquivo", "danger", "Documento");
          }
        }
      });
    },
    AddPartnerDoc() {
      if (this.isCreating) {
        // Add
        this.loadingModal = true;
        let partnerDoc = this.infoPartnerDoc;
        partnerDoc = JSON.parse(JSON.stringify(partnerDoc));
        delete partnerDoc.Url;
        var formData = this.GetFormData(partnerDoc);
        formData.append("File", this.partnerDocFile, this.partnerDocFile.name);
        this.$store
          .dispatch("AddPartnerDoc", formData)
          .then(() => {
            this.$makeToast(
              "Sucesso ao adicionar o documento",
              "success",
              "Documento"
            );
            this.ListPartnerDoc();
            this.$bvModal.hide("mFormPartnerDoc");
          })
          .catch((error) => {
            this.$makeToast(
              "Não foi possível adicionar o documento",
              "danger",
              "Documento",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListPartnerDoc();
    },
    ListPartnerDoc: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.IdPartner)) this.countFilter++;
      if (hasValue(this.filter.CodePartnerDocType)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Partner.Id": this.filter.IdPartner,
          "Object.PartnerDocType.Code": this.filter.CodePartnerDocType,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListPartnerDoc", { params: data })
        .then(
          (response) => {
            this.partnerDocs = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          },
          (error) => {
            this.$makeToast(
              "Não foi possível listar os documentos",
              "danger",
              "Documentos",
              error
            );
          }
        )
        .finally(() => {
          this.loadingList = false;
        });
    },
    ListPartnerDocType: function () {
      let data = {
        ...this.pagination
      };
      this.$store
        .dispatch("ListPartnerDocType", { params: data })
        .then((response) => {
          this.partnerDocTypes = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página",
            "danger",
            "Erro ao obter lista de tipos de documentos",
            error
          );
        });
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    ResetFilter: function () {
      this.filter = {
        IdPartner: null,
        CodePartnerDocType: null,
      };
      this.ListPartnerDoc();
    },
    GetPartnerDoc: function (id, seeing, download) {
      if (download) this.loadingDownload = true;
      else this.loadingModal = true;
      if (!download) {
        if (seeing == true) {
          this.isSeeing = true;
          this.modalTitle = "Detalhes do documento";
        }
        this.isCreating = false;
        this.ResetInfoPartnerDoc();
        this.OpenMPartnerDoc();
      }
      this.$store
        .dispatch("GetPartnerDoc", { id: id })
        .then((response) => {
          this.infoPartnerDoc = response;

          if (download && hasValue(response.Url)) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Documento"
            );
            window.open(response.Url, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Não foi possível buscar as informações do documento",
            "danger",
            "Documento",
            error
          );
        })
        .finally(() => {
          if (download) this.loadingDownload = false;
          else this.loadingModal = false;
        });
    },
    ConfirmDeletePartnerDoc: function(e, nameDoc, namePartner ,i) {
      e.preventDefault();
      this.$makeMsgBox(
        `Você tem certeza que deseja remover ${nameDoc} do parcerio ${namePartner}?`,
        "Confirmar",
        this.DeletePartnerDoc,
        i,
        nameDoc
      );
    },
    DeletePartnerDoc: function(i, nameDoc) {
      this.$store
        .dispatch("DeletePartnerDoc", { id: i })
        .then(() => {
          this.$makeToast(
            `${nameDoc} foi removido da sua lista de arquivos`,
            "success",
            "Arquivo"
          );
          this.ListPartnerDoc();
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover o arquivo",
            error
          );
        });
    },
    GetReport: function(ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = {
          "Object.Partner.Id": this.filter.IdPartner,
          "Object.PartnerDocType.Code": this.filter.CodePartnerDocType
      };
      this.$store
        .dispatch("ReportPartnerDoc", { params: data })
        .then(response => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(
            "Falha ao gerar relatório, tente novamente mais tarde.",
            "danger",
            "Geração de relatório",
            error
          );
        })
        .finally(() => {
          setTimeout(() => {
            $(".dropdown-menu").removeClass("show");
            this.loadingReport = false;
          }, 250);
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/pages/partnerDocs.vue